export const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

// ─── Date helpers ────────────────────────────────────────────────────────────

function today() {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}

function offset(base, days) {
  const d = new Date(base);
  d.setDate(d.getDate() + days);
  return d;
}

function mondayOf(date) {
  const day = date.getDay();
  return offset(date, -(day === 0 ? 6 : day - 1));
}

// Each preset carries its own date computation so getDateRange is a plain lookup.
export const DATE_PRESETS = [
  {
    key: 'last_7',
    label: 'Last 7 days',
    getRange() { const end = today(); return { start: offset(end, -6), end }; },
  },
  {
    key: 'last_30',
    label: 'Last 30 days',
    getRange() { const end = today(); return { start: offset(end, -29), end }; },
  },
  {
    key: 'this_week',
    label: 'This week',
    getRange() { const end = today(); return { start: mondayOf(end), end }; },
  },
  {
    key: 'last_week',
    label: 'Last week',
    getRange() {
      const thisMonday = mondayOf(today());
      return { start: offset(thisMonday, -7), end: offset(thisMonday, -1) };
    },
  },
  {
    key: 'this_month',
    label: 'This month',
    getRange() {
      const t = today();
      return { start: new Date(t.getFullYear(), t.getMonth(), 1), end: t };
    },
  },
  {
    key: 'last_month',
    label: 'Last month',
    getRange() {
      const t = today();
      return {
        start: new Date(t.getFullYear(), t.getMonth() - 1, 1),
        end:   new Date(t.getFullYear(), t.getMonth(), 0),
      };
    },
  },
];

export const PERIOD_OPTIONS = [
  { val: 'week',    label: 'Week' },
  { val: 'month',   label: 'Month' },
  { val: 'quarter', label: 'Qtr' },
];

export const DEFAULT_DATE_PRESET   = 'last_30';
export const DEFAULT_COHORT_PERIOD = 'month';
export const RETENTION_WEEKS       = 12;
export const EVENT_PLACEHOLDER     = 'Select an event\u2026';

export const COHORT_INFO = 'Each row is a cohort of users who first triggered this event in the same period. Columns show what % returned and triggered the event again in each subsequent period \u2014 P0 is always 100% (when users first appeared). Steep early drop-off signals onboarding friction; a flattening curve means retained users are sticking. Use period switching to spot short-term drop-off (week) vs long-run retention trends (month/quarter).';

export const MSG = {
  retentionLoading:   'Loading retention data\u2026',
  retentionEmpty:     'No retention data available.',
  cohortLoading:      'Loading cohort data\u2026',
  cohortEmpty:        'No cohort data available for this event.',
  chartLoading:       'Loading chart\u2026',
  cohortPrompt:       'Select an event to view cohort retention',
  searchPlaceholder:  'Search events\u2026',
  clearSelection:     'Clear selection',
  noEvents:           'No events found',
  customRange:        'Custom range',
  apply:              'Apply',
  backToList:         'Product Events',
  detailEmpty:        'No events in this period.',
  toggleChart:        'Toggle daily chart',
};

export { PAGE_SIZES } from '../shared.constants.js';

export const LIST_COLUMNS = [
  { key: 'name',           label: 'Event' },
  { key: 'total_triggers', label: 'Triggers' },
  { key: 'chart',          label: '' },
];

export const DETAIL_BASE_COLUMNS = [
  { key: 'time',       label: 'Time' },
  { key: 'user_email', label: 'User' },
];

export const CARD_TITLE = {
  retention: `Feature Retention \u2014 Weekly Active Users (last ${RETENTION_WEEKS} weeks)`,
};

export const PERIOD_PREFIX = { week: 'W', month: 'M', quarter: 'Q' };

export const HEATMAP_EMPTY_COLOR = '#f3f4f6';
